module.exports = __webpack_public_path__ + "media/cursor-select.9a7063f3.mp3";